import { render, staticRenderFns } from "./StarRatingExecute.vue?vue&type=template&id=f1bf31fc&scoped=true"
import script from "./StarRatingExecute.vue?vue&type=script&lang=js"
export * from "./StarRatingExecute.vue?vue&type=script&lang=js"
import style0 from "./StarRatingExecute.vue?vue&type=style&index=0&id=f1bf31fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bf31fc",
  null
  
)

export default component.exports